import { Pipe, PipeTransform } from '@angular/core';
import { Filter } from '@model-main/eda/compute/filtering/filter';
import { IntervalFilter } from '@model-main/eda/compute/filtering/interval-filter';
import { smarterNumber } from '@shared/pipes/number-pipes/smarter-number.pipe';

function fullFilterName(filter: Filter, withColumnNames: boolean): string {
    if (!filter) {
        return '';
    }

    if (filter.name != null && filter.name !== '') {
        return filter.name;
    }

    if (Filter.isAnumFilter(filter)) {
        const values = filter.values
            .map(value => value === '' ? '(no value)' : value)
            .join(', ');

        if (withColumnNames) {
            if (filter.values.length > 1) {
                return `${filter.column} in ${values}`;
            }

            return `${filter.column}: ${values}`;
        }

        return values;
    }

    if (Filter.isAllFilter(filter)) {
        return 'All';
    }

    if (Filter.isIntervalFilter(filter)) {
        let beginning;
        let end;
        switch (filter.closed) {
            case IntervalFilter.ClosedMode.LEFT:
                beginning = '[';
                end = ')';
                break;
            case IntervalFilter.ClosedMode.RIGHT:
                beginning = '(';
                end = ']';
                break;
            case IntervalFilter.ClosedMode.BOTH:
                beginning = '[';
                end = ']';
                break;
            case IntervalFilter.ClosedMode.NEITHER:
                beginning = '(';
                end = ')';
        }
        const left = filter.left === -Number.MAX_VALUE ? '-∞' : smarterNumber(filter.left);
        const right = filter.right === Number.MAX_VALUE ? '+∞' : smarterNumber(filter.right);
        const interval = `${beginning}${left},${right}${end}`;

        if (withColumnNames) {
            return `${filter.column} in ${interval}`;
        }

        return interval;
    }

    if (Filter.isAndFilter(filter)) {
        return filter.filters
            .map(childFilter => fullFilterName(childFilter, withColumnNames))
            .join(', ');
    }

    if (Filter.isMissingValueFilter(filter)) {
        return '(no value)';
    }

    // NOT IMPLEMENTED
    return 'UNNAMED';
}

export function filterName(filter: Filter, sliced: boolean = true, withColumnNames: boolean = false): string {
    const fullName = fullFilterName(filter, withColumnNames);
    return sliced ? fullName.slice(0, 100) : fullName;
}

@Pipe({
    name: 'filterName',
    pure: true
})
export class FilterNamePipe implements PipeTransform {
    transform(filter: Filter, sliced: boolean = true, withColumnNames: boolean = false): string {
        return filterName(filter, sliced, withColumnNames);
    }
}
